<template>
<div
  id="preview-recipient-email"
>
  <div class="modal" id="preview-recipient-email-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Previewing {{ lbl }} Email</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
          <div class="modal-body">
            <flash></flash>
            <spinner size="large" v-if="loading" />
            <pre
              v-if="pre"
              v-html="email"
            ></pre>
            <div
              v-else
              v-html="email"
            ></div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >Close</button>
          </div>
      </div>
    </div>
  </div>

  <button
    type="button"
    :class="btnClasses"
    @click="getEmail"
    data-toggle="modal"
    data-target="#preview-recipient-email-modal"
  >
    Preview {{ lbl }} Email

    <span
      class="badge badge-secondary"
    >
      Debug
    </span>
  </button>
</div>
</template>

<script>
import Flash from '@/components/Flash'

import FlashStore from '@/stores/FlashStore'

import Spinner from 'vue-simple-spinner'

export default {
  data () {
    return {
      email: undefined,
      loading: false
    }
  },

  props: {
    'btnBlock': {
      type: Boolean
    },

    'lbl': {
      type: String,
      default: 'Recipient'
    },

    'pre': {
      type: Boolean,
      default: false
    },

    'url': {
      type: String,
      required: true
    }
  },

  components: {
    'flash': Flash,
    'spinner': Spinner
  },

  computed: {
    btnClasses () {
      let classes = [
        'btn', 'btn-warning', 'form-group'
      ]

      if (this.btnBlock) {
        classes.push('btn-block')
      } else {
        classes.push('btn-sm')
      }

      return classes.join(' ')
    }
  },

  methods: {
    getEmail () {
      this.email = ''
      FlashStore.clear()
      this.loading = true
      this.$http.get(
        this.url
      ).then((resp) => {
        this.email = resp.body
      }).catch(this.$root.processErrors).finally(() => {
        this.loading = false
      })
    },

    previewInNewWindow () {
      let win = window.open('', `Email Preview`, 'resizable,scrollbars,status')
      win.document.write('<html><body>Test</body></html>')
    }
  }
}
</script>

<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
  }
}

#preview-recipient-email {
  display: inline-block;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewRecipientEmail.vue